import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        bucket_id:     filters.bucket_id,
        date:       Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'objectStorageAssigned',
        endpoint:           endpoints.storage.storageObjectAssigned,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => {
            if (response.results) {
                return response.results.map(item => ({
                    assignedTb: item.assigned_tb,
                    usedTb:     item.used_tb,
                    period:     item.period
                }));
            }

            return [];
        }
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/objectStorageAssigned.js